export default{
  methods: {
    clearErrorByField(_, fieldName) {
      this.errors.remove(fieldName);
    }
  }
}